module.exports = __webpack_public_path__ + "img/6.6c9d7a15.svg";